import ViewportMgr from 'coreClasses/view/ViewportMgr';

import {IResponsivenessFields, IResponsivenessFieldsTransformed} from './IGridContentfulColumn';

export const transformResponsivenessData = (data: IResponsivenessFields): IResponsivenessFieldsTransformed => {
	const breakpointsList = ViewportMgr.getBreakpoints();
	const breakpointsListLen = breakpointsList.length;
	const result = {};

	// Exit if the data is not an object
	if (data === null || typeof data !== 'object') {
		return result;
	}

	for (let i = 0; i < breakpointsListLen; i += 1) {
		const breakpoint = breakpointsList[i];
		let targetBreakpoint: typeof breakpoint | 'default' = breakpoint;
		result[breakpoint] = {};

		// Default points to XS
		if (targetBreakpoint === 'xs') {
			targetBreakpoint = 'default';
		}

		if (typeof data[targetBreakpoint] !== 'undefined') {
			const responsivenessData = data[targetBreakpoint];
			const hasSpan = responsivenessData.span && responsivenessData.span !== 'inherit';

			if (hasSpan) {
				result[breakpoint].col = responsivenessData.span;

				const hasOffset = responsivenessData.offset && responsivenessData.offset !== 'inherit';
				const resetOffset = !responsivenessData.offset && breakpoint !== 'sm' && breakpoint !== 'xs';

				if (hasOffset || resetOffset) {
					result[breakpoint].offset = responsivenessData.offset;
				}
			}

			const hasOrder = typeof responsivenessData.order === 'number';

			if (hasOrder) {
				result[breakpoint].order = responsivenessData.order;
			}

			const isHidden = getIsHiddenColumnValue(data, breakpoint);

			if (isHidden) {
				result[breakpoint].hide = isHidden;
			}
		}
	}

	return result;
};

export const getIsHiddenColumnValue = (data: IResponsivenessFields, breakPoint): boolean => {
	// Exit if the data is not an object
	if (data === null || typeof data !== 'object') {
		return false;
	}

	let currentBreakpoint = breakPoint;

	// Hidden doesn't have an XS breakpoint
	if (currentBreakpoint === 'xs') {
		currentBreakpoint = 'sm';
	}

	return data[currentBreakpoint].hide || false;
};
